import React, {useState} from "react";
import Styles from './styles.module.scss';

import copyIcon from '../../theme/assets/svg/ftf_cabinet_referral_copy_icon.svg';
import {useDispatch, useSelector} from "react-redux";
import {setRefCode, setRefCodeFailure} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";

const CabinetReferralMain = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const referralsMain = useSelector(store => store.cabinet.referralsMain);
    const formErr = useSelector(store => store.cabinet.refCodeStatusErr);

    const [code, setCode] = useState('');

    const refHandler = () =>{
        if (code.length > 4){
            dispatch(setRefCode(code));
            setCode('');
        }
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={Styles.textWrap}>
                    <div className={Styles.textWrapTitle}>{t('Реферальная программа')}</div>
                    {/*<div className={Styles.textWrapSubTitle}>{t('Пригласите друзей и зарабатывайте больше')}!</div>*/}
                    <div className={Styles.textWrapNote}>
                        {t('Реферальная программа позволяет получать бонусы за активное участие и приглашение новых пользователей')}.
                    </div>
                    <div className={Styles.statWrap}>
                        <div className={Styles.statWrapTitle}>{t('Статистика')}:</div>
                        <div className={Styles.statBox}>
                            <div className={Styles.statBoxRow}>
                                <div className={Styles.statBoxRowItem}>
                                    <div className={Styles.statBoxRowItemName}>{t('ПРИГЛАШЕН')}</div>
                                    <div className={Styles.statBoxRowItemValue}>{referralsMain?.invited} <span>{t('')}friends</span></div>
                                </div>
                                <div className={Styles.statBoxRowItem}>
                                    <div className={Styles.statBoxRowItemName}>{t('ПОЛУЧЕНО')}</div>
                                    <div className={Styles.statBoxRowItemValue}>{referralsMain?.received} <span>FTF</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${Styles.posWrap}`}>
                    <div className={Styles.valuesWrap}>
                        <div className={Styles.valuesWrapTitle}>{t('Пригласите друзей и зарабатывайте больше')}:</div>
                        <div className={Styles.valuesBox}>
                            <div className={Styles.valuesBoxRow}>
                                <div className={Styles.valuesBoxRowItem}>
                                    <div className={Styles.valuesBoxRowItemName}>{t('ССЫЛКА')}</div>
                                    <div className={Styles.valuesBoxRowItemValue}>{`${window.location.origin}/sign-up/ref/${referralsMain?.code}`}</div>
                                    <div className={Styles.valuesBoxRowItemAbsBtn} onClick={()=>{navigator.clipboard.writeText(`${window.location.origin}/sign-up/ref/${referralsMain?.code}`)}}>
                                        <img src={copyIcon} alt="copy link"/>
                                    </div>
                                </div>
                                <div className={Styles.valuesBoxRowItem}>
                                    <div className={Styles.valuesBoxRowItemName}>{t('КОД')}</div>
                                    <div className={Styles.valuesBoxRowItemValue}>{referralsMain?.code}</div>
                                    <div className={Styles.valuesBoxRowItemAbsBtn} onClick={()=>{navigator.clipboard.writeText(referralsMain?.code)}}>
                                        <img src={copyIcon} alt="copy link"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.statWrap}>
                        <div className={Styles.statWrapTitle}>{t('Вы были приглашены')}?</div>
                        <div className={Styles.statBox}>
                            {referralsMain?.inviter ?
                                <div className={`${Styles.statBoxRow} ${Styles.statBoxRowCustom}`}>
                                    <div className={`${Styles.statBoxRowItem} ${Styles.statBoxRowItemCustom}`}>
                                        <div className={Styles.inputTitle}>{t('Ваш пригласитель')}:</div>
                                        <div className={`${Styles.statBoxRowItemInviter}`}>{referralsMain?.inviter}</div>
                                    </div>
                                </div> :
                                <div className={Styles.statBoxRow}>

                                    <div className={`${Styles.statBoxRowItem} ${formErr?.code ? Styles.statBoxRowItemErr : null}`}>
                                        <div className={Styles.inputTitle}>{t('ВВЕДИТЕ КОД ПРИГЛАШЕНИЯ')}</div>
                                        <input
                                            type="text"
                                            placeholder="AGZK726"
                                            value={code}
                                            onChange={(e)=>{setCode(e.target.value)}}
                                            onKeyDown={(event)=>{
                                                if (formErr.code){
                                                    delete formErr.code;
                                                    dispatch(setRefCodeFailure(formErr));
                                                }
                                            }}
                                        />
                                        <div className={`${Styles.inputErr}`}>{formErr?.code ? formErr.code : null}</div>
                                    </div>
                                    <div className={code.length > 4 ? Styles.ftfBorderBtn : Styles.ftfDisabledBtn} onClick={()=>{refHandler()}}>{t('Применить')}</div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetReferralMain;